import React from 'react';
import Post from '../Projects/index';

import styles from '../assets/styles/projects.module.scss';
import { ProjectData, Thumb } from '../interfaces';
import axios from '../const/axios';
import { ThumbnailContext } from '../const/contexts';

export default class Projects extends React.Component<{
	sections: {
		[key: string]: ProjectData[]
	}
	thumbnailDictionary: {[key: string]: Thumb}
}> {

	public state = {
		sections: {} as {
			[key: string]: ProjectData[]
		},
		thumbnailDictionary: {} as {[key: string]: Thumb}
	}

	async componentDidMount() {
		try {
			let token = Math.random().toString(32).slice(2);
			axios.get('/projects.json?token=' + token)
				.then(({data}) => {
					this.setState({sections: data});
				});
			axios('/thumbnails.json?token=' + token)
				.then(({data}) => {
					this.setState({thumbnailDictionary: data});
				});
		} catch (e) {
			console.error(e);
		}
	}

	render() {
		return Object.entries(this.state.sections).map(([section, posts], j) => {
			return (
				<ThumbnailContext.Provider key={['ThumbnailContext', j].join('.')} value={this.state.thumbnailDictionary}>
					<div className={styles.section} key={['section', j].join('.')}>
						<h2>
							{section === 'other' ? '\u200b' : section.toLowerCase()}
						</h2>
						{posts.map((p, i) => {
							return (
								<Post
									key={p.id}
									i={i}
									{...p}
								/>
							)}
						)}					
						<br />
					</div>					
				</ThumbnailContext.Provider>
			)
		});
	}
}
